import { FormControl, InputAdornment, OutlinedInput } from "@mui/material";
import React from "react";

const InputForPrice = ({ value, onChange }) => {
  return (
    <FormControl fullWidth variant="outlined">
      <OutlinedInput
        id="outlined-adornment-weight"
        value={value}
        fullWidth
        onChange={(e) => onChange(e.target.value)}
        endAdornment={<InputAdornment position="end">сум</InputAdornment>}
        aria-describedby="outlined-weight-helper-text"
        inputProps={{
          "aria-label": "weight",
          style: { padding: "20px" },
          step: "0.1",
          lang: "en-US",
        }}
        type="number"
      />
    </FormControl>
  );
};

export default InputForPrice;
